import { useIsShoppingAgentEnabled } from '@/features/shop/services/ShoppingAgent/hooks'
import { DynamicShoppingAgentPopover } from '@/features/shop/components/ShoppingAgent/DynamicShoppingAgentPopover'

export const ShoppingAgentEntryButton = () => {
  const isEnabled = useIsShoppingAgentEnabled()

  if (!isEnabled) return null

  return <DynamicShoppingAgentPopover />
}
